import clsx from "clsx";

import classes from "./WhereLine.module.css";

/**
 * The page speaking above a card: one quiet line naming the call, page or
 * session each thing on the card came from, so the card itself stays true to
 * the app (DESIGN.md § App Cards on Marketing Pages).
 */
export function WhereLine({ children }: { children: React.ReactNode }) {
  return <div className={classes.line}>{children}</div>;
}

interface WhereSourceProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  /** The footnote number the card's text cites this source by. */
  note?: number;
  className?: string;
}

export function WhereSource({ icon, children, note, className }: WhereSourceProps) {
  return (
    <span className={clsx(classes.source, className)}>
      {note !== undefined && <sup className={classes.note}>{note}</sup>}
      {icon}
      {children}
    </span>
  );
}

/** Joins two sources into a path, the thing on the left reaching the one on the right. */
export function WhereArrow() {
  return (
    <span className={classes.arrow} aria-hidden>
      &rarr;
    </span>
  );
}
